/* eslint-disable react-hooks/exhaustive-deps */
import React, { lazy, Suspense, useEffect } from 'react';

import './App.css';
import { Switch, Route, useLocation } from 'react-router-dom';
import $ from 'jquery';


import UpButton from './Dashboard/Pages/Home/Components/Up_Button/Up_Button';


// PAGES
const Home = lazy(() => import('./Dashboard/Pages/Home/Home'));
const SeaboardCompanies = lazy(() => import('./Dashboard/Pages/Seaboard_Companies/Seaboard_Companies'));
const CareerForm = lazy(() => import('./Dashboard/Pages/CareerForm/CareerForm'));
const Contact = lazy(() => import('./Dashboard/Pages/Contact/Contact'));
const SeaBoardFamily = lazy(() => import('./Dashboard/Pages/SeaboardFamily/SeaBoardFamily'));
const Gallery = lazy(() => import('./Dashboard/Pages/GalleryPage/SeaBoardFamily'));

const Values = lazy(() => import('./Dashboard/Pages/Values/Values'));
const Blogs = lazy(() => import('./Dashboard/Pages/Blogs/Blogs'));
const BlogInner = lazy(() => import('./Dashboard/Pages/Blogs/BlogInner'));
const BlogCreate = lazy(() => import('./Dashboard/Pages/Blogs/BlogCreate'));
const Foundation = lazy(() => import('./Dashboard/Pages/RationPage/Rahion.jsx'));



const SeaboardServices = lazy(() => import('./Dashboard/Pages/Seaboard_Companies/pages/SeaboardServices'));
const SeaboardCityLog = lazy(() => import('./Dashboard/Pages/Seaboard_Companies/pages/SeaboardCityLog.jsx'));
const SeaboardMena = lazy(() => import('./Dashboard/Pages/Seaboard_Companies/pages/SeaboardMena.jsx'));
const SeaboardQuartal = lazy(() => import('./Dashboard/Pages/Seaboard_Companies/pages/SeaboardQuartal.jsx'));
const SeaboardQFS = lazy(() => import('./Dashboard/Pages/Seaboard_Companies/pages/SeaboardQFS.jsx'));
const SeaboardPlutus = lazy(() => import('./Dashboard/Pages/Seaboard_Companies/pages/SeaboardPlutus.jsx'));
const SeaboardOceanport = lazy(() => import('./Dashboard/Pages/Seaboard_Companies/pages/SeaboardOceanport.jsx'));
const SeaboardOceanworld = lazy(() => import('./Dashboard/Pages/Seaboard_Companies/pages/SeaboardOceanworld.jsx'));
const SeaboardSeatech = lazy(() => import('./Dashboard/Pages/Seaboard_Companies/pages/SeaboardSeatech.jsx'));
const SeaboardLogistics = lazy(() => import('./Dashboard/Pages/Seaboard_Companies/pages/SeaboardLogistics.jsx'));







const App = () => {

  const location = useLocation();


  useEffect(() => {
    $('.loading-screen').removeClass('fading');
    setTimeout(() => {
      $('.loading-screen').addClass('fading');
    }, );
  }, [location])

  return (
    <>
      <div className="loading-screen fading"><div>Seaboard</div></div>
          <UpButton />

      <Switch>

        <Route
          exact
          path="/"
          render={
            () => <Suspense fallback={ <div className="loading-screen fading"><div>Seaboard</div></div>}><Home /></Suspense>
          }
        />
  
        <Route
          exact
          path="/Seaboard_Companies"
          render={
            () => <Suspense fallback={ <div className="loading-screen fading"><div>Seaboard</div></div>}><SeaboardCompanies /></Suspense>
          }
        />
           <Route
          exact
          path="/ration"
          render={
            () => <Suspense fallback={ <div className="loading-screen fading"><div>Seaboard</div></div>}><Foundation /></Suspense>
          }
        />

        <Route
          exact
          path="/careers"
          render={
            () => <Suspense fallback={ <div className="loading-screen fading"><div>Seaboard</div></div>}><CareerForm /></Suspense>
          }
        />
        <Route
          exact
          path="/contact"
          render={
            () => <Suspense fallback={ <div className="loading-screen fading"><div>Seaboard</div></div>}><Contact /></Suspense>
          }
        />
             <Route
          exact
          path="/Seaboard_Services"
          render={
            () => <Suspense fallback={ <div className="loading-screen fading"><div>Seaboard</div></div>}><SeaboardServices /></Suspense>
          }
        />
                <Route
          exact
          path="/Seaboard_Seatech"
          render={
            () => <Suspense fallback={ <div className="loading-screen fading"><div>Seaboard</div></div>}><SeaboardSeatech /></Suspense>
          }
        />
                <Route
          exact
          path="/Seaboard_City"
          render={
            () => <Suspense fallback={ <div className="loading-screen fading"><div>Seaboard</div></div>}><SeaboardCityLog /></Suspense>
          }
        />
                <Route
          exact
          path="/Seaboard_Mena"
          render={
            () => <Suspense fallback={ <div className="loading-screen fading"><div>Seaboard</div></div>}><SeaboardMena /></Suspense>
          }
        />
                <Route
          exact
          path="/Seaboard_Quartal"
          render={
            () => <Suspense fallback={ <div className="loading-screen fading"><div>Seaboard</div></div>}><SeaboardQuartal /></Suspense>
          }
        />
                <Route
          exact
          path="/Seaboard_qfs"
          render={
            () => <Suspense fallback={ <div className="loading-screen fading"><div>Seaboard</div></div>}><SeaboardQFS /></Suspense>
          }
        />
                <Route
          exact
          path="/Seaboard_plutus"
          render={
            () => <Suspense fallback={ <div className="loading-screen fading"><div>Seaboard</div></div>}><SeaboardPlutus /></Suspense>
          }
        />
                <Route
          exact
          path="/Seaboard_ocean"
          render={
            () => <Suspense fallback={ <div className="loading-screen fading"><div>Seaboard</div></div>}><SeaboardOceanport /></Suspense>
          }
        />
                <Route
          exact
          path="/Seaboard_world"
          render={
            () => <Suspense fallback={ <div className="loading-screen fading"><div>Seaboard</div></div>}><SeaboardOceanworld /></Suspense>
          }
        />
                 <Route
          exact
          path="/Seaboard_Logistics"
          render={
            () => <Suspense fallback={ <div className="loading-screen fading"><div>Seaboard</div></div>}><SeaboardLogistics /></Suspense>
          }
        />
        <Route
          exact
          path="/seaboard_family"
          render={
            () => <Suspense fallback={ <div className="loading-screen fading"><div>Seaboard</div></div>}><SeaBoardFamily /></Suspense>
          }
        />
          <Route
          exact
          path="/gallery"
          render={
            () => <Suspense fallback={ <div className="loading-screen fading"><div>Seaboard</div></div>}><Gallery /></Suspense>
          }
        />
 
        <Route
          exact
          path="/values"
          render={
            () => <Suspense fallback={ <div className="loading-screen fading"><div>Seaboard</div></div>}><Values /></Suspense>
          }
        />

        <Route
          exact
          path="/blogs"
          render={
            () => <Suspense fallback={ <div className="loading-screen fading"><div>Seaboard</div></div>}><Blogs /></Suspense>
          }
        />

        <Route
          exact
          path="/blogs/:id"
          render={
            () => <Suspense fallback={ <div className="loading-screen fading"><div>Seaboard</div></div>}><BlogInner /></Suspense>
          }
        />

        <Route
          exact
          path="/blog/create"
          render={
            () => <Suspense fallback={ <div className="loading-screen fading"><div>Seaboard</div></div>}><BlogCreate /></Suspense>
          }
        />
      </Switch>


    </>
  )

}

export default App;
